/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type CreatePaymentRecordDto = {
    /**
     * Associated sales order ID
     */
    orderId: number;
    /**
     * Payment method
     */
    method: CreatePaymentRecordDto.method;
    /**
     * Expected payment amount
     */
    amountExpected: number;
    /**
     * Actual amount paid
     */
    amountPaid: number;
    /**
     * Change given
     */
    changeGiven?: number;
};
export namespace CreatePaymentRecordDto {
    /**
     * Payment method
     */
    export enum method {
        CASH = 'CASH',
        QR = 'QR',
        CARD = 'CARD',
    }
}

